define('specific/mosaic/views/RowView', [
    'specific/mosaic/templates/row'
], function(tpl, Factory) {

    var RowView = Mazarine.View.extend({

        events: {
        },

        template: tpl,

        className: "maz-row-view",

        initialize: function(){
        },

        getRenderDatas: function() {
            var obj = this.model.toJSON();

            var rowsLayout = [
                {
                    alignBottom: false,
                    itemSizes: ['lg', 'sm', 'sm']
                },
                {
                    alignBottom: true,
                    itemSizes: ['sm', 'lg', 'sm']
                },
                {
                    alignBottom: false,
                    itemSizes: ['sm', 'lg', 'lg']
                },
                {
                    alignBottom: false,
                    itemSizes: ['lg', 'sm', 'sm']
                },
                {
                    alignBottom: true,
                    itemSizes: ['sm', 'lg', 'sm']
                },
                {
                    alignBottom: false,
                    itemSizes: ['sm', 'lg', 'lg']
                }
            ];

            var itemCount = 0;

            for( var i = 0; i < Math.min( Math.ceil( obj.rowDatas.length / rowsLayout[0].itemSizes.length ), rowsLayout.length ); i++ ) {
                rowsLayout[i].items = [];

                for( var j = 0; j < rowsLayout[i].itemSizes.length; j++ ) {
                    if( itemCount < obj.rowDatas.length ) {
                        rowsLayout[i].items.push( {
                            size: rowsLayout[i].itemSizes[j],
                            datas: obj.rowDatas[ itemCount ]
                        } );
                    } else {
                        rowsLayout[i].items.push( {
                            size: rowsLayout[i].itemSizes[j],
                            datas: null
                        } );
                    }
                    itemCount++;
                }
            }

            obj.rows = rowsLayout;

            return obj;
        },

        afterRender: function() {
            this.model.set('isReady', true);
        }
    });

    return RowView;
});
